import * as Language from './languages';

export { Language };
export default Language;
